import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import TradeRuleBuilder from '@/modules/trade-rule-builder/components/trade-rule-builder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import { isAlphaFlashHost } from '@/shared/theme/export';

export class TradeRuleBuilderWidget implements NewsWidget {
  get defaultRoute(): string {
    return '/';
  }

  get defaultTitle(): string {
    return 'AlphaFlash Automator';
  }

  async hasPermission(permissions: string[]) {
    return isAlphaFlashHost();
  }

  shouldHideToUser?(permissions: string[]) {
    return !isAlphaFlashHost();
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faRobot} /> AlphaFlash Automator
      </>
    );
  }

  get id(): string {
    return 'trade-rule-builder';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <TradeRuleBuilder />,
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return <>TradeRuleBuilder</>;
  }
}
